// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 651) return "static/chunks/651.08cf58d00dce04e2.js";
	if (chunkId === 899) return "static/chunks/899.7134f6f674ae3d47.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"33":"cb02a8f49e670a5e","349":"84f3e83af0b67273","776":"e1fad5b1a1bd8eab","920":"e33283358e48defa"}[chunkId] + ".js";
};